/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

function clone( obj ) {
	return JSON.parse( JSON.stringify(obj) );
}

const OppositeFilterOperator = {
	in: 'notin',
	notin: 'in',
	lt: 'gt',
	gt: 'lt',
	between: 'notbetween',
	notbetween: 'between'
};
function oppositeFilterOperator ( op ) {
	return OppositeFilterOperator[op] || null;
}

function allFiltersAfterReplacement( indexToReplace, newLocalFilter, localFilters = []) {
	const newLocalFilters = [];
	localFilters.forEach(  (filter, index) => {
		if( index === indexToReplace ) {
			newLocalFilters.push(newLocalFilter);
		} else {
			newLocalFilters.push( clone(filter) ) ;
		}
	} );
	return newLocalFilters;
}

function getRelatedInvertedFilterWidgetSpecs(widgetSpec, visApi) {

	const newWidgetSpecs = [];
	let localFilters = visApi.getAllFiltersAsLocalFiltersForPinning();
	if( !localFilters) {
		localFilters = [];
	}
	localFilters.forEach( (filterToReplace, index) => {
		const operator = oppositeFilterOperator( filterToReplace.operator );
		if( operator ) {
			const newLocalFilter = clone(filterToReplace);
			newLocalFilter.operator = operator;

			const clonedWidgetSpec = clone(widgetSpec);
			clonedWidgetSpec.localFilters = allFiltersAfterReplacement(index, newLocalFilter, localFilters);

			newWidgetSpecs.push({
				spec: clonedWidgetSpec,
				title: visApi.getTitle() + ' - inverted filter'
			});
		}
	} );

	return newWidgetSpecs;
}

const OppositeTopBottom = {
	bottompercent: 'toppercent',
	toppercent: 'bottompercent',
	topcount: 'bottomcount',
	bottomcount: 'topcount'
};
function oppositeTopBottomType( type ) {
	return OppositeTopBottom[type] || null;
}



function replaceSelectionItem( newWidgetSpec, newSelectionItem, viewIndex, dataItemIndex, selectionIndex ) {

	const dataView = newWidgetSpec.data.dataViews[viewIndex];
	const dataItem = dataView.dataItems[dataItemIndex];
	dataItem.selection[selectionIndex] = newSelectionItem;
}

function getRelatedInvertedTopBottomWidgetSpecs(widgetSpec, visApi) {

	const newWidgetSpecs = [];

	const dataViews = widgetSpec.data.dataViews || [];
	dataViews.forEach( (viewItem, viewIndex) => {

		const dataItems = viewItem.dataItems || [];
		dataItems.forEach( (item, dataItemIndex) => {

			const selectionItems = item.selection || [];

			selectionItems.forEach( (selection, selectionIndex) => {
				if(selection && selection.topBottom) {
					const newItem = clone(selection);
					newItem.topBottom.type = oppositeTopBottomType(newItem.topBottom.type);

					const clonedWidgetSpec = clone(widgetSpec);
					replaceSelectionItem(clonedWidgetSpec, newItem, viewIndex, dataItemIndex, selectionIndex );
					newWidgetSpecs.push({
						spec: clonedWidgetSpec,
						title: visApi.getTitle() + ' - inverted top bottom'
					});
				}
			} );

		});
	} );

	return newWidgetSpecs;
}

export {
	clone,
	getRelatedInvertedFilterWidgetSpecs,
	getRelatedInvertedTopBottomWidgetSpecs
};



// WEBPACK FOOTER //
// ./src/js/features/compare/recommendations/ClientSideRecommendationUtils.js